import Layout from "@/components/Layout";
import HomeKr from "@/pages/kr/Home";
import HomeEn from "@/pages/en/Home";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import PrivacyPolicy from "@/pages/kr/PrivacyPolicy";
import TermsOfUse from "@/pages/kr/TermsOfUse";
import PrivacyPolicyEn from "@/pages/en/PrivacyPolicy";
import TermsOfUseEn from "@/pages/en/TermsOfUse";
import useModal from "./hooks/useModal";
import ContactUsModal from "./components/ContactUsmodal";
import { useLanguage } from "./hooks/useLanguage";
import LanguageRedirect from "./pages/LanguageRedirect";

function App() {
  const { isOpenModal, openModal, closeModal } = useModal();

  return (
    <Router>
      <Routes>
        <Route element={<Layout openModal={openModal} />}>
          <Route path="/" element={<LanguageRedirect />} />
          <Route path="/kr" element={<HomeKr openModal={openModal} />} />
          <Route path="/kr/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/kr/terms-of-use" element={<TermsOfUse />} />
          <Route path="/en" element={<HomeEn openModal={openModal} />} />
          <Route path="/en/privacy-policy" element={<PrivacyPolicyEn />} />
          <Route path="/en/terms-of-use" element={<TermsOfUseEn />} />
        </Route>
      </Routes>
      <ContactUsModal isOpenModal={isOpenModal} closeModal={closeModal} />
    </Router>
  );
}

export default App;
